import { Slide, useTheme } from "@mui/material";
import React from "react";
import ReactMarkdown from "react-markdown";
import { AvatarContainer, Container, MessageBox, MessageContainer } from "./AISupportChatMessageBox.styles";
import avatarIcon from "../../../../assets/avatar.svg";
import { Icon } from "../../../Icon";
import { ChatAgentMessage } from "../../AISupportChat.types";
import AISupportChatSpinner from "../AISupportChatSpinner/AISupportChatSpinner.component";

interface AISupportChatMessageBoxProps {
  index: number;
  message: ChatAgentMessage;
}

const AISupportChatMessageBox = ({
  index,
  message
}: AISupportChatMessageBoxProps) => {
  const theme = useTheme();
  const isAI = message.sender === "assistant";


  const MessageAvatar = () => {
    return (
      <>
        { isAI ? (
          <img src={ avatarIcon } alt={ "Avatar" } style={ { width: "100%", height: "100%" } }/>
        ) : (
          <Icon
            icon="Icons_Profilo"
            color={ theme.customColors.textWidget }
            size={ 37 }
          />
        ) }
      </>
    );
  };

  return (
    <Slide direction={ "up" } in mountOnEnter unmountOnExit>
      <Container isAI={ isAI } messageIndex={ index } gap={ "10px" }>
        <AvatarContainer theme={ theme } isAI={ isAI }>
          <MessageAvatar />
        </AvatarContainer>
        <MessageContainer theme={ theme } isAI={ isAI }>
          { message.response === "" ? (
            <AISupportChatSpinner />
          ) : (
            <MessageBox>
              <ReactMarkdown>{ message.response }</ReactMarkdown>
            </MessageBox>
          ) }
        </MessageContainer>
      </Container>
    </Slide>
  );
};

export default AISupportChatMessageBox;
